import dictionary from 'app/modules/TimeFilter/TimeFilter.dictionary.json';

export type PrematchFilterFromBack = {
  value: number;
  output: number;
  template: 0 | 1 | 2;
};
export const isKeyInDictionary = (key: string): key is keyof typeof dictionary => {
  return key in dictionary;
};
